import React from 'react';
import { useIsMobile } from '../../../helpers/useIsMobile';

interface SubPageFooterProps {
  onBack: () => void;
  backLabel?: string;
  isBackDisabled?: boolean;
  /** Aviso exibido acima dos botões (ex.: redirecionamento ao gov.br). */
  notice?: React.ReactNode;
  /** Ação extra (ex.: SubPageFooterPrimaryButton) renderizada ao lado do botão secundário. */
  children?: React.ReactNode;
}

export function SubPageFooter({ onBack, backLabel = 'Voltar', isBackDisabled, notice, children }: SubPageFooterProps) {
  const isMobile = useIsMobile();
  return (
    <div className="px-4 py-3 border-t border-gray-lighter bg-white shrink-0">
      {notice}
      <div className="flex justify-end gap-3">
        <button
          onClick={onBack}
          disabled={isBackDisabled}
          className={`px-5 py-2 rounded-full border-2 border-primary text-primary text-[13px] font-semibold hover:bg-primary/5 transition-colors cursor-pointer bg-transparent disabled:opacity-50 disabled:cursor-not-allowed ${isMobile ? 'w-full h-11 flex items-center justify-center' : ''
            }`}
        >
          {backLabel}
        </button>
        {children}
      </div>
    </div>
  );
}

interface SubPageFooterPrimaryButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  children: React.ReactNode;
}

/** Botão primário do rodapé — mesmo estilo do "Salvar" do PatientData. */
export function SubPageFooterPrimaryButton({
  onClick,
  disabled,
  isLoading,
  loadingText,
  children,
}: SubPageFooterPrimaryButtonProps) {
  const isMobile = useIsMobile();
  const isDisabled = !!disabled || !!isLoading;
  const isEnabled = !disabled && !isLoading;
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`flex items-center justify-center gap-1.5 px-5 py-2 rounded-full border-0 text-[13px] font-semibold transition-all ${isMobile ? 'w-full h-11' : ''
        }`}
      style={{
        backgroundColor: isEnabled ? 'var(--color-primary)' : 'var(--color-primary-soft)',
        color: isEnabled ? '#fff' : 'var(--color-primary-muted)',
        cursor: isEnabled ? 'pointer' : 'not-allowed',
      }}
    >
      {isLoading && loadingText ? loadingText : children}
    </button>
  );
}
